<script setup lang="ts">
import { useAuthStore } from "@/stores/authStore";
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import UserAvatar from "@/components/shared/UserAvatar.vue";

defineProps<{
  compacted?: boolean;
  itemSize?: number;
}>();

defineEmits<{
  (e: "closeDrawer"): void;
}>();

const authStore = useAuthStore();
const { loggedAsStaff } = storeToRefs(authStore);

const { t } = useI18n();
</script>

<template>
  <v-card
    class="tw:!mt-2 tw:!mx-[16px] tw:!overflow-visible"
    data-testid="user-menu-button"
  >
    <div class="tw:flex tw:flex-row tw:justify-between tw:items-center tw:overflow-visible">
      <div class="tw:flex tw:flex-row tw:items-center tw:!gap-2 tw:overflow-visible tw:pb-1">
        <user-avatar
          :user="loggedAsStaff"
          rounded="0"
          :color="compacted ? 'surface' : 'background'"
          :size="itemSize"
          class="tw:!rounded tw:!transition-all tw:!duration-500"
        />
        <!-- <div
              v-if="authPersonRole"
              class="tw:flex tw:gap-0.5 tw:absolute tw:!left-1/2 tw:md:left-0 tw:-translate-x-1/2 tw:z-layer-1"
              :class="compacted ? 'tw:bottom-0' : 'tw:md:-bottom-1'"
            >
              <v-chip
                color="primary"
                variant="flat"
                density="compact"
                :size="compacted ? 'x-small' : 'small'"
                :class="chipClasses"
              >
                {{ StaffTypeShortMap[authPersonRole as EPracticeStaffType] }}
              </v-chip>
              <v-chip
                v-if="isImpersonating"
                color="purple"
                variant="flat"
                density="compact"
                :size="compacted ? 'x-small' : 'small'"
                :class="chipClasses"
              >
                <v-icon icon="mdi-incognito" />
              </v-chip>
            </div> -->
        <div class="tw:flex tw:flex-col tw:text-md tw:justify-center">
          <p>{{ loggedAsStaff?.first_name }}</p>
          <p>{{ loggedAsStaff?.last_name }}</p>
        </div>
      </div>
      <div>
        <v-btn
          v-tippy="t('generic.navbar.menuUser.logout')"
          data-testid="logout-button"
          :aria-label="t('generic.navbar.menuUser.logout')"
          color="background"
          icon
          class="tw:!rounded tw:min-w-auto tw:!transition-all tw:!duration-500"
          :size="itemSize"
          :elevation="0"
          @click="
            () => {
              $emit('closeDrawer');
              authStore.userLogout();
            }
          "
        >
          <v-icon icon="mdi-logout" />
        </v-btn>
      </div>
    </div>
  </v-card>
</template>
